/**
 * Created by Christof Sander on 07.12.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'search'
			],
			core: {
				check_callback: function(operation, node, node_parent, node_position, more) {
					var result = false;
					if(operation === 'move_node'){
						var treesComponent;
						if(more.origin.element && (treesComponent = getComponent($(more.origin.element).closest('.base_trees_trees')))){
							var nodeData = treesComponent.getNodeData(node.id);
							var parentNodeData;
							if(node_parent.id != '#') parentNodeData = treesComponent.getNodeData(node_parent.id);

							const moveOutsideLayoutGranted = !treesComponent.config.limitParentTemplateID || treesComponent.config.extendRouteContentsByLayouts

							result = (
								(
									nodeData.type === 'component'
									&&
									(
										// prevent move to location outside the actual layout if the corresponding permissions has not been granted to the actual user.
										!!moveOutsideLayoutGranted
										||
										!!parentNodeData
									)
									&&
									(
										// free usage of move-node allowed
										(
											nodeData.config
											&&
											nodeData.config.freeUsageAllowed
										)
										||
										// new parent allows free child usage
										(
											parentNodeData
											&&
											parentNodeData.config
											&&
											parentNodeData.config.freeChildUsageAllowed
										)
										||
										(
											parentNodeData != undefined
											&&
											(
												// move component to other section
												(
													parentNodeData.type === 'section'
													&&
													!nodeData.parentComponentID
												)
												||
												// move component to compatible parent component
												(
													parentNodeData.type === 'component'
													&&
													parentNodeData.subType != 'layout'
													&&
													parentNodeData.componentID != undefined
													&&
													parentNodeData.componentID == nodeData.parentComponentID
												)
											)
										)
										||
										(
											// TODO: check where this flag is in use.
											treesComponent.config.showParentLayoutsAccess
											&&
											!parentNodeData
										)
									)
								)
							);
						}
					}
					return result;
				}
			}
			// plugins: [
			// 'contextmenu', 'dnd', 'search',
			// 'state', 'types', 'wholerow'
			// 'state',
			// 'types',
			// 'checkbox'
			// 'contextmenu',
			// 'dnd'
			// ]
		}
	}
};
